<template>
	<v-card v-if="isLoading" class="d-flex justify-center align-center" height="612px">
		<v-progress-circular
			indeterminate
			size="64"
			color="primary"
		></v-progress-circular>
	</v-card>
	<v-card v-else-if="!isLoading">
		<v-card-title>
			<div
				style="font-weight:600 !important;"
				class="my-2 text-center"
			>
				Modifica Esito {{ modificaDiMassa ? 'in massa' : ''}} - {{ datiEsito.codiceCliccatore }} - {{ datiEsito.nomeInDatiDiFatturazione }} {{ datiEsito.cognomeInDatiDiFatturazione }}
			</div>
		</v-card-title>
		<v-card-text>
			<v-row v-if="modificaDiMassa" class="mb-3 warning--text">
				<v-col>
					IMPORTANTE:<br>
					- I campi non attivi non sovrascriveranno i dati già presenti <br>
					- I campi attivi ma lasciati vuoti cancelleranno i dati già presenti
				</v-col>
			</v-row>
			<v-form ref="esitoClickdayForm">
				<v-row>
					<v-col class="py-0">
						<!--<div-->
						<!--	:style="`color:${scdColor}`"-->
						<!--	class="mb-1"-->
						<!--&gt;-->
						<!--	Esito Click Day-->
						<!--</div>-->
						<v-checkbox
							v-if="modificaDiMassa"
							v-model="esitoClickdayEnabled"
							:label="esitoClickdayEnabled ? 'Attivo' : 'Non attivo'"
							class="mt-0 mb-2"
							hide-details
						></v-checkbox>
						<v-select
							v-model="datiEsito.esitoClickday"
							:items="opzioniEsitoClickday"
							label="Esito Click Day"
							:disabled="modificaDiMassa && !esitoClickdayEnabled"
							class="pt-0"
							outlined
							dense
							:rules="modificaDiMassa && esitoClickdayEnabled ? [vincoli.required] : []"
						></v-select>
					</v-col>
					<!--@change="setCompensoFinalePlaceholder"-->
				</v-row>
				
				<v-row v-if="possoMostrareTempoClickday && !modificaDiMassa">
					<v-col class="py-0">
						<v-text-field
							v-model="datiEsito.tempoClickday"
							label="Tempo Click Day"
							outlined
							dense
							required
							:rules="[vincoli.required]"
						></v-text-field>
					</v-col>
				</v-row>
				
				<v-row v-if="!modificaDiMassa">
					<v-col class="py-0">
						<v-text-field
							v-model="datiEsito.compensoFinalePersonalizzatoEsitiProvvisori"
							label="Compenso personalizzato esiti provvisori"
							:readonly="!computedAmIAdmin"
							outlined
							dense
							type="number"
							:rules="[vincoli.unsignedSmallInteger]"
						></v-text-field>
					</v-col>
				</v-row>
				
				<v-row v-if="!modificaDiMassa">
					<v-col class="py-0">
						<v-text-field
							v-model="datiEsito.compensoFinalePersonalizzatoEsitiDefinitivi"
							label="Compenso personalizzato esiti definitivi"
							:readonly="!computedAmIAdmin"
							outlined
							dense
							type="number"
							:rules="[vincoli.unsignedSmallInteger]"
						></v-text-field>
					</v-col>
				</v-row>
				
				<v-row>
					<v-col class="py-0">
						<v-checkbox
							v-if="modificaDiMassa"
							v-model="statoPagamentoCompensoEnabled"
							:label="statoPagamentoCompensoEnabled ? 'Attivo' : 'Non attivo'"
							class="mt-0 mb-2"
							hide-details
						></v-checkbox>
						<v-select
							v-model="datiEsito.statoPagamentoCompenso"
							:items="opzioniStatoPagamentoCompenso"
							label="Stato pagamento compenso"
							:disabled="modificaDiMassa && !statoPagamentoCompensoEnabled"
							:readonly="!computedAmIAdmin"
							clearable
							class="pt-0"
							outlined
							dense
						></v-select>
					</v-col>
				</v-row>
				
				<v-row>
					<v-col class="py-0">
						<v-checkbox
							v-if="modificaDiMassa"
							v-model="dataDelBonificoEnabled"
							:label="dataDelBonificoEnabled ? 'Attivo' : 'Non attivo'"
							class="mt-0 mb-2"
							hide-details
						></v-checkbox>
						<v-menu
							v-if="computedAmIAdmin"
							v-model="dataDelBonificoMenu"
							:close-on-content-click="false"
							transition="scale-transition"
							offset-y
							max-width="290px"
							min-width="auto"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									:value="dateITFormatDDMMYYYY(datiEsito.dataDelBonifico)"
									@input="datiEsito.dataDelBonifico = $event"
									label="Data del bonifico"
									persistent-hint
									append-icon="mdi-calendar"
									@click:append="dataDelBonificoMenu = true"
									:disabled="modificaDiMassa && !dataDelBonificoEnabled"
									outlined
									dense
									v-bind="attrs"
									v-on="on"
									clearable
								></v-text-field>
							</template>
							<v-date-picker
								v-model="datiEsito.dataDelBonifico"
								no-title
								@input="dataDelBonificoMenu = false"
								locale="it-IT"
								first-day-of-week="1"
							></v-date-picker>
						</v-menu>
						<v-text-field
							v-else
							:value="dateITFormatDDMMYYYY(datiEsito.dataDelBonifico)"
							label="Data del bonifico"
							append-icon="mdi-calendar"
							readonly
							outlined
							dense
						></v-text-field>
					</v-col>
				</v-row>
				
				<v-row v-if="(!computedAmIAdmin && !modificaDiMassa) || computedAmIAdmin">
					<v-col class="py-0">
						<v-checkbox
							v-if="modificaDiMassa"
							v-model="noteCompensoEnabled"
							:label="noteCompensoEnabled ? 'Attivo' : 'Non attivo'"
							class="mt-0 mb-2"
							hide-details
						></v-checkbox>
						<v-textarea
							v-model="datiEsito.noteCompenso"
							value=""
							label="Note compenso"
							:disabled="modificaDiMassa && !noteCompensoEnabled"
							:readonly="!computedAmIAdmin"
							outlined
							name="note_compenso"
						></v-textarea>
					</v-col>
				</v-row>
			</v-form>
			
			<v-alert
				type="error"
				:value="alertAlmenoUnCampoAbilitato"
				transition="scale-transition"
			>
				Abilita almeno un campo
			</v-alert>
			
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				class="px-4 white--text"
				style="text-transform:none;"
				depressed
				rounded
				:color="scdColor"
				:disabled="salvataggioEsitoClickday"
				@click="chiudiDialog()"
			>
				Annulla
			</v-btn>
			<v-btn
				class="px-4 white--text"
				style="text-transform:none;"
				depressed
				rounded
				:color="scdOrange"
				:loading="salvataggioEsitoClickday"
				@click="salvaEsitoClickday()"
			>
				Salva
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	props: ['datiEsitoClickday', 'idBando', 'modificaDiMassa'],
	data() {
		return {
			isLoading: false,
			opzioniEsitoClickday: [],
			opzioniStatoPagamentoCompenso: [],
			datiEsito: {
				idCliccatore: null, // è presente in caso si sia modificando un cliccatore che non sia quello loggato
				idsCliccatori: [], // è presente in caso di modifica di massa
				esitoClickday: null,
				tempoClickday: null,
				// totaleCompensoVittoria: null,
				// totaleCompensoPerdita: null,
				compensoFinalePersonalizzatoEsitiProvvisori: null,
				compensoFinalePersonalizzatoEsitiDefinitivi: null,
				dataDelBonifico: null,
				noteCompenso: null,
				statoPagamentoCompenso: null,
				codiceCliccatore: null,
				nomeInDatiDiFatturazione: null,
				cognomeInDatiDiFatturazione: null
			},
			
			// usate solo durante la modifica di massa
			esitoClickdayEnabled: false,
			statoPagamentoCompensoEnabled: false,
			noteCompensoEnabled: false,
			dataDelBonificoEnabled: false,
			alertAlmenoUnCampoAbilitato: false,
			
			dataDelBonificoMenu: false,
			salvataggioEsitoClickday: false,
		}
	},

	async created() {
		this.isLoading = true;
		await this.getOpzioni();
		this.datiEsito = Object.assign({}, this.datiEsitoClickday);
		this.isLoading = false;
	},

	computed: {
		possoMostrareTempoClickday() {
			return this.datiEsito.esitoClickday == 'Vincente' ||
			this.datiEsito.esitoClickday == 'Vincente Esiti Definitivi' ||
			this.datiEsito.esitoClickday == 'Non vincente' ||
			this.datiEsito.esitoClickday == 'In attesa di esito'
		},
		almenoUnCampoAbilitato() {
			return this.modificaDiMassa
				&& (this.esitoClickdayEnabled
				|| this.statoPagamentoCompensoEnabled
				|| this.noteCompensoEnabled
				|| this.dataDelBonificoEnabled)
		}
	},

	methods: {
		getOpzioni() {
			return axios.get('/clickdayit/opzioni-modifica-esito')
				.then(response => {
					this.opzioniStatoPagamentoCompenso = response.data.opzioni_stato_pagamento_compenso;
					this.opzioniEsitoClickday = response.data.opzioni_esito_clickday;
				})
		},
		// setCompensoFinalePlaceholder(esito) {
		// 	if (esito == 'Vincente') this.compensoFinalePlaceholder = this.datiEsito.totaleCompensoVittoria.toString()
		// 	else if (esito == 'Non vincente' || esito == 'Non assegnato') this.compensoFinalePlaceholder = this.datiEsito.totaleCompensoPerdita.toString();
		// 	else this.compensoFinalePlaceholder = '0';
		// },
		salvaEsitoClickday() {
			if(this.$refs.esitoClickdayForm.validate()) {
				this.salvataggioEsitoClickday = true;
				
				let datiDaAggiornare = {
					// this.datiEsito.idCliccatore è diverso da null solo se si sta modificando un cliccatore dalla pagina Cliccatori
					// e quindi si è passato l'id del cliccatore via prop
					// altrimenti il valore sarà null e significa che si sta modificando il cliccatore loggato
					utente_id: this.modificaDiMassa ? null : this.datiEsito.idCliccatore,
					utenti_ids: this.modificaDiMassa ? this.datiEsito.idsCliccatori : null,
					bando_id: this.idBando
				}
				
				// modifica di massa nella pagina compensi
				if (this.modificaDiMassa) {
					if (!this.almenoUnCampoAbilitato) {
						this.alertAlmenoUnCampoAbilitato = true;
						setTimeout(() => {
							this.alertAlmenoUnCampoAbilitato = false
						},5000)
						
						this.salvataggioEsitoClickday = false;
						return;
					}
					
					if (this.esitoClickdayEnabled) datiDaAggiornare.esito_clickday = this.datiEsito.esitoClickday;
					if (this.statoPagamentoCompensoEnabled) datiDaAggiornare.stato_pagamento = this.datiEsito.statoPagamentoCompenso
					if (this.noteCompensoEnabled) datiDaAggiornare.note_compenso = this.datiEsito.noteCompenso
					if (this.dataDelBonificoEnabled) datiDaAggiornare.data_bonifico = this.datiEsito.dataDelBonifico;
				}
				else { // modifica singolo cliccatore
					datiDaAggiornare.esito_clickday = this.datiEsito.esitoClickday;
					datiDaAggiornare.tempo_clickday = this.datiEsito.tempoClickday;
					datiDaAggiornare.compenso_finale_personalizzato_esiti_provvisori = this.datiEsito.compensoFinalePersonalizzatoEsitiProvvisori;
					datiDaAggiornare.compenso_finale_personalizzato_esiti_definitivi = this.datiEsito.compensoFinalePersonalizzatoEsitiDefinitivi;
					datiDaAggiornare.stato_pagamento = this.datiEsito.statoPagamentoCompenso;
					datiDaAggiornare.note_compenso = this.datiEsito.noteCompenso;
					datiDaAggiornare.data_bonifico = this.datiEsito.dataDelBonifico;
				}
				
				axios.post('/clickdayit/salva_esito_clickday', datiDaAggiornare)
					.then(async response => {
						this.$emit('dati-esito-clickday-aggiornati');
						this.$emit('chiudi-dialog');
					})
					.finally(() => {
						this.salvataggioEsitoClickday = false;
					})
			}
		},
		chiudiDialog() {
			this.$emit('chiudi-dialog')
		}
	}
}
</script>

<style scoped>

</style>